export const Colors = {
  blue: '#44b1c6',
  green: '#17b027',
  red: 'red',
  orange: 'orange',
  neonOrange: '#FF5F1F'
};
